export const TG_SUPPORT_LINK = "https://t.me/B_KonBot";
export const TARIFF_ID = 1;
export const YOOKASSA_REDIRECT = "yookassa_redirect";
export const CARD_CHANGED_REDIRECT = "card_changed_true";
